import React from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import IFramePage from 'components/core/IFramePage';
import { oldSelfServiceLink } from 'config';

const subTab = {
  Payments: 'Scheduledx20Payments',
  Transactions: 'Transactions',
  Variations: 'Variations',
  Contract: 'Contract',
  PaymentMethod: 'Variations',
  Activities: 'Callx20History',
};

const CustomerEmbedFrame = (props) => {
  const params = useParams();
  const { url } = useRouteMatch();
  const matchSplit = url.split('/');
  const tab = matchSplit.length === 4 ? matchSplit[3] : '';

  return (
    <IFramePage
      frameSrc={
        oldSelfServiceLink +
        `/Customer/Detail?debitsuccessId=${params.adfitNo}&activeTab=${subTab[tab]}&HideMenu=true`
      }
    />
  );
};

CustomerEmbedFrame.propTypes = {};

export default CustomerEmbedFrame;
